<svg viewBox="0 0 407.1 59.8">
	<polyline
		class="pattern_st1"
		points="213.3,59.8 221.6,39.9 398.5,39.9 390.2,59.8 	"
	/>
	<polyline
		class="pattern_st0"
		points="243.5,19.9 134.8,19.9 143.1,0 251.8,0 243.5,19.9 	"
	/>
	<polyline
		class="pattern_st0"
		points="56.7,39.9 65,19.9 321.2,19.9 312.9,39.9 	"
	/>
	<polyline
		class="pattern_st0"
		points="132.2,19.9 128.9,19.9 137.2,0 140.5,0 132.2,19.9 	"
	/>
	<polyline
		class="pattern_st0"
		points="126.3,19.9 123,19.9 131.3,0 134.6,0 126.3,19.9 	"
	/>
</svg>
